import { FloatLabelDesignTokens } from '@primeuix/themes/types/floatlabel';

export const FloatLabel: FloatLabelDesignTokens = {
  root: {
    active: {
      fontSize: '0.825rem',
      fontWeight: '600',
    },
  },
  colorScheme: {
    light: {
      root: {
        activeColor: '{primary.600}',
      },
    },
    dark: {
      root: {
        activeColor: '{primary.200}',
        focusColor: '{primary.400}',
      },
    },
  },
  css: () => `
  .p-floatlabel {
    flex: 1;
  }`,
};
